
module.exports = function(n, options){
  options = options || {};
  var d = options.delimiter || ',';
  var s = options.separator || '.';
  n = n.toString().split('.');
  n[0] = n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + d);
  return n.join(s);
};


//////////////////
// WEBPACK FOOTER
// ../~/humanize-number/index.js
// module id = 231
// module chunks = 0